import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { KeyRound } from "lucide-react";
import { routes } from "@/lib/routes";
import { Card } from "@/components/ui/Card";
import { PageTitle } from "@/components/ui/Heading";
import { AuthFlow } from "@/components/auth/AuthFlow";
interface PrivateEntityAccessProps {
  entityLabel: "Angebot" | "Anfrage";
  returnTo: string;
  hasSession: boolean;
}

/** Recover a private link without revealing whether it belongs to another account. */
export function PrivateEntityAccess(t0) {
  const $ = _c(13);
  const {
    entityLabel,
    returnTo,
    hasSession
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-tenant-primary/10 text-tenant-primary"><KeyRound className="h-6 w-6" aria-hidden="true" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== entityLabel) {
    t2 = <PageTitle>{entityLabel} öffnen</PageTitle>;
    $[1] = entityLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = hasSession ? "Mit dem aktuellen Zugang l\xE4sst sich dieser Link nicht \xF6ffnen. Pr\xFCfen Sie den Link oder melden Sie sich mit der E-Mail-Adresse an, an die er gesendet wurde." : "Melden Sie sich mit der E-Mail-Adresse an, an die dieser Link gesendet wurde. Anschlie\xDFend gelangen Sie wieder hierher.";
  let t4;
  if ($[3] !== t3) {
    t4 = <p className="mb-8 text-on-surface-variant leading-relaxed">{t3}</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = hasSession ? "Mit einem anderen Konto anmelden" : "Anmelden, um fortzufahren";
  let t6;
  if ($[5] !== returnTo || $[6] !== t5) {
    t6 = <Card padding="lg"><AuthFlow variant="modal" returnTo={returnTo} title={t5} subtitle={"Ihr Link bleibt w\xE4hrend der Anmeldung erhalten."} /></Card>;
    $[5] = returnTo;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="mt-6 text-center text-sm text-on-surface-variant">Sie benötigen Hilfe?{" "}<Link href={routes.accessRecovery} className="font-medium text-tenant-primary underline underline-offset-4">Zugang wiederherstellen</Link></p>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t6) {
    t8 = <section className="mx-auto max-w-xl py-8 md:py-16">{t1}{t2}{t4}{t6}{t7}</section>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}